document.addEventListener('turbo:load', function() {
    if ('IntersectionObserver' in window) {
      const lazyImages = [].slice.call(document.querySelectorAll('img.lazyload'));

      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.original;
            lazyImage.classList.remove('lazyload');
            lazyImage.classList.remove('blur-md');
            observer.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }
  });